export default __webpack_public_path__ + "static/media/captura.9dc82e3c.png";